(function () {
  if (!document.body.classList.contains('shop-collection')) return;

  var STORAGE_KEY = 'twShopAvailable';
  var availableOn = false;
  var injecting = false;
  var didInitialCollapse = false;

  try {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === '0' || stored === '1') availableOn = stored === '1';
  } catch (e) {}

  function availableLabel() {
    var tabs = document.querySelector('.shop-collection-tabs');
    return (tabs && tabs.getAttribute('data-available-label')) || 'Available';
  }

  function isMobile() {
    return window.innerWidth <= 991;
  }

  function persistAvailable(on) {
    availableOn = !!on;
    document.body.classList.toggle('shop-available-only', availableOn);
    document.querySelectorAll('.shop-filter-available .switch').forEach(function (input) {
      input.checked = availableOn;
    });
    try {
      sessionStorage.setItem(STORAGE_KEY, availableOn ? '1' : '0');
    } catch (e) {}
  }

  function stripAvailableFromUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('available')) return;
      url.searchParams.delete('available');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function bindAvailableInputs() {
    document.querySelectorAll('.shop-filter-available .switch').forEach(function (input) {
      input.checked = availableOn;
      if (input.dataset.shopBound === '1') return;
      input.dataset.shopBound = '1';
      input.addEventListener('change', function (event) {
        persistAvailable(event.target.checked);
      });
    });
  }

  function createAvailableControl() {
    var wrap = document.createElement('div');
    wrap.className = 'shop-filter-available';
    wrap.innerHTML =
      '<input id="shop-filter-available" class="switch" type="checkbox"' +
      (availableOn ? ' checked' : '') +
      '>' +
      '<label class="shop-filter-available__label" for="shop-filter-available">' +
      availableLabel() +
      '</label>';
    var input = wrap.querySelector('input');
    input.dataset.shopBound = '1';
    input.addEventListener('change', function (event) {
      persistAvailable(event.target.checked);
    });
    return wrap;
  }

  function facetsInner() {
    return document.querySelector('#usf_container .usf-facets-container .usf-facets__inner');
  }

  function sortFields() {
    return (window.usf && usf.settings && usf.settings.search && usf.settings.search.sortFields) || [];
  }

  function sortLabel(value) {
    var translations = (window.usf && usf.settings && usf.settings.translation) || {};
    return translations['sortBy_' + value] || value || '';
  }

  function currentSort() {
    var fields = sortFields();
    return (window.usf && usf.queryRewriter && usf.queryRewriter.sort) || fields[0] || '';
  }

  function closeSort() {
    document.querySelectorAll('.shop-filter-sort[data-shop-custom-sort="1"]').forEach(function (el) {
      el.classList.remove('is-open');
      var menu = el.querySelector('.shop-filter-sort__menu');
      var btn = el.querySelector('.shop-filter-sort__button');
      if (menu) menu.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function renderSort(wrap) {
    if (!wrap) return;
    var fields = sortFields();
    var current = currentSort();
    var btn = wrap.querySelector('.shop-filter-sort__button');
    var menu = wrap.querySelector('.shop-filter-sort__menu');
    if (!btn || !menu) return;
    btn.innerHTML = '<span>' + sortLabel(current) + '</span>';
    menu.innerHTML = fields
      .map(function (field) {
        var selected = field === current ? ' is-selected' : '';
        return (
          '<button type="button" class="shop-filter-sort__option' +
          selected +
          '" data-sort="' +
          field +
          '">' +
          sortLabel(field) +
          '</button>'
        );
      })
      .join('');
  }

  function createSortControl() {
    var wrap = document.createElement('div');
    wrap.className = 'shop-filter-sort';
    wrap.setAttribute('data-shop-custom-sort', '1');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'shop-filter-sort__button';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-haspopup', 'listbox');

    var menu = document.createElement('div');
    menu.className = 'shop-filter-sort__menu';
    menu.hidden = true;

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var willOpen = menu.hidden;
      closeSort();
      closeOtherFacets();
      if (!willOpen) return;
      menu.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('click', function (event) {
      var option = event.target.closest('[data-sort]');
      if (!option || !window.usf || !usf.queryRewriter) return;
      usf.queryRewriter.sort = option.getAttribute('data-sort');
      closeSort();
      renderSort(wrap);
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);
    renderSort(wrap);
    return wrap;
  }

  function restoreVueSort() {
    var toolbarList = document.querySelector('#usf_container .collection-toolbar .collection-toolbar__button-list');
    var sortButton = document.querySelector('#usf_container #usf-new-sortbtn');
    var sortContainer = sortButton && sortButton.closest('.collection-toolbar__button-container');
    var popover = document.getElementById('collection-sort-popoverv2');

    if (toolbarList && sortContainer && !toolbarList.contains(sortContainer)) {
      toolbarList.appendChild(sortContainer);
    }
    if (toolbarList && popover && !toolbarList.contains(popover)) {
      toolbarList.appendChild(popover);
    }

    document.querySelectorAll('#usf_container .usf-facets-container .shop-filter-sort').forEach(function (slot) {
      if (slot.getAttribute('data-shop-custom-sort') === '1') return;
      slot.remove();
    });
  }

  function injectChrome() {
    var inner = facetsInner();
    if (!inner) return false;

    restoreVueSort();

    if (!inner.querySelector('.shop-filter-available')) {
      inner.insertBefore(createAvailableControl(), inner.firstChild);
    }

    var sortSlot = inner.querySelector('.shop-filter-sort[data-shop-custom-sort="1"]');
    if (!sortSlot) sortSlot = createSortControl();
    if (sortSlot.parentNode !== inner || inner.lastElementChild !== sortSlot) {
      inner.appendChild(sortSlot);
    }

    inner.classList.add('shop-filter-bar');
    observeInner(inner);
    return true;
  }

  function observeInner(inner) {
    if (!inner || inner.dataset.shopObserved === '1') return;
    inner.dataset.shopObserved = '1';
    new MutationObserver(function () {
      window.setTimeout(function () {
        mount({ collapse: false });
      }, 0);
    }).observe(inner, { childList: true });
  }

  function collapseAllFacets() {
    closeOtherFacets();
  }

  function facetKey(facet) {
    if (!facet) return '';
    if (facet.id) return facet.id;
    var label = facet.querySelector('.usf-label');
    return label ? label.textContent.trim() : '';
  }

  function closeOtherFacets(keepKey) {
    if (isMobile()) return;
    document.querySelectorAll('#usf_container .usf-facets-container .usf-facet:not(.usf-collapsed)').forEach(function (openFacet) {
      if (keepKey && facetKey(openFacet) === keepKey) return;
      var openTitle = openFacet.querySelector('.usf-title');
      if (openTitle) openTitle.click();
    });
  }

  function bindFacetExclusiveOpen() {
    if (document.body.dataset.shopExclusive === '1') return;
    document.body.dataset.shopExclusive = '1';
    document.addEventListener('click', function (event) {
      if (isMobile() || !event.isTrusted) return;
      var title = event.target.closest('#usf_container .usf-facets-container .usf-title');
      if (!title) return;
      var facet = title.closest('.usf-facet');
      if (!facet) return;
      closeSort();
      var clickedKey = facetKey(facet);
      window.setTimeout(function () {
        closeOtherFacets(clickedKey);
      }, 0);
    }, true);
  }

  function bindOutsideClose() {
    if (document.body.dataset.shopOutsideClose === '1') return;
    document.body.dataset.shopOutsideClose = '1';
    document.addEventListener('click', function (event) {
      if (isMobile()) return;
      if (event.target.closest('.shop-filter-sort')) return;
      closeSort();
      if (event.target.closest('.usf-facet') || event.target.closest('.popover')) return;
      document.querySelectorAll('#usf_container .usf-facets-container .usf-facet:not(.usf-collapsed) .usf-title').forEach(function (title) {
        title.click();
      });
    });
  }

  function markUsfReady() {
    if (waitForFreshUsf) return false;
    var results = document.querySelector('#usf_container .usf-results');
    var bar = document.querySelector('#usf_container .usf-facets-container .shop-filter-bar');
    if (!results || !bar) return false;
    if (!results.querySelector('.product-card, [data-usf-pid], .usf-sr-product, product-card')) return false;
    document.body.classList.add('shop-usf-ready');
    return true;
  }

  var currentHandle = (function () {
    var path = window.location.pathname;
    if (path.indexOf('strap-selector') !== -1) return 'strap-selector';
    if (path.indexOf('watch-selector') !== -1) return 'watch-selector';
    return '';
  })();
  var switchToken = 0;
  var switching = false;
  var waitForFreshUsf = false;

  function tabLinkFor(handle) {
    return document.querySelector('.shop-collection-tabs__link[data-shop-handle="' + handle + '"]');
  }

  function setActiveTab(handle) {
    document.querySelectorAll('.shop-collection-tabs__link').forEach(function (item) {
      var on = item.getAttribute('data-shop-handle') === handle;
      item.classList.toggle('is-active', on);
      if (on) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });
  }

  function setActiveFallback(handle) {
    document.querySelectorAll('.shop-collection-fallback').forEach(function (el) {
      var on = el.getAttribute('data-shop-fallback') === handle;
      el.classList.toggle('is-active', on);
      el.hidden = !on;
    });
  }

  function updateTitle(link) {
    var nextTitle = link && link.getAttribute('data-shop-title');
    if (!nextTitle) return;
    var current = document.title;
    var parts = current.split(/\s+[–—-]\s+/);
    document.title = parts.length > 1 ? nextTitle + ' – ' + parts.slice(1).join(' – ') : nextTitle;
  }

  function applyCollectionContext(link) {
    var collectionId = link.getAttribute('data-shop-collection-id');
    var defaultSort = link.getAttribute('data-shop-default-sort');
    var handle = link.getAttribute('data-shop-handle');
    if (collectionId) window._usfCollectionId = Number(collectionId) || collectionId;
    if (defaultSort) window._usfCollectionDefaultSort = defaultSort;
    if (window.usf && usf.platform) usf.platform.collection = handle;
  }

  function refreshUsf(link) {
    if (!window.usf || !usf.search || !usf.fetch) return false;
    var search = usf.search;
    var sort = (link && link.getAttribute('data-shop-sort')) || '';
    search.page = 1;
    search.itemsLoaded = 0;
    search.itemsOffset = 0;
    search.term = '';
    search.facetFilters = null;
    search.sortBy = sort;
    usf.fetch(search);
    return true;
  }

  function switchCollection(link, options) {
    var handle = link && link.getAttribute('data-shop-handle');
    var collectionId = link && link.getAttribute('data-shop-collection-id');
    if (!handle || !collectionId) return false;
    if (!options || !options.fromPop) {
      if (handle === currentHandle) return true;
    }

    var token = ++switchToken;
    switching = true;
    waitForFreshUsf = true;
    currentHandle = handle;

    setActiveTab(handle);
    setActiveFallback(handle);
    document.body.classList.remove('shop-usf-ready');
    applyCollectionContext(link);
    updateTitle(link);

    if (!options || !options.fromPop) {
      try {
        var nextUrl = new URL(link.href, window.location.origin);
        ['available', 'page'].forEach(function (key) {
          nextUrl.searchParams.delete(key);
        });
        Array.from(nextUrl.searchParams.keys()).forEach(function (key) {
          if (key.indexOf('uff_') === 0 || key.indexOf('usf_') === 0) nextUrl.searchParams.delete(key);
        });
        var sort = link.getAttribute('data-shop-sort');
        if (sort) nextUrl.searchParams.set('usf_sort', sort);
        history.pushState({ shopCollection: handle }, '', nextUrl.pathname + nextUrl.search);
      } catch (e) {
        switching = false;
        waitForFreshUsf = false;
        return false;
      }
    }

    waitForFreshUsf = 'listening';
    var didFetch = refreshUsf(link);
    if (!didFetch && window.usf && usf.event) {
      usf.event.add('init', function () {
        if (token !== switchToken) return;
        refreshUsf(link);
      });
    }

    window.setTimeout(function () {
      if (token !== switchToken) return;
      switching = false;
      waitForFreshUsf = false;
    }, 4000);

    var tabsEl = document.querySelector('.shop-collection-tabs');
    if (tabsEl) {
      var top = tabsEl.getBoundingClientRect().top + window.scrollY - 8;
      if (window.scrollY > top) window.scrollTo(0, Math.max(0, top));
    }

    return true;
  }

  function warmupHiddenFallback() {
    document.querySelectorAll('.shop-collection-fallback:not(.is-active) img').forEach(function (img, index) {
      if (index > 7) return;
      var src = img.currentSrc || img.src;
      if (!src) return;
      var preload = new Image();
      preload.decoding = 'async';
      preload.src = src;
    });
  }

  function prefetchUsfCollection(link) {
    if (!link || !window.usf || !usf.settings) return;
    var collectionId = link.getAttribute('data-shop-collection-id');
    var svc = usf.settings.searchSvcUrl;
    var key = usf.settings.siteId;
    if (!collectionId || !svc || !key) return;
    var take = (usf.queryRewriter && usf.queryRewriter.itemsPerPage) || 24;
    var params = new URLSearchParams({
      q: '',
      apiKey: String(key),
      collection: String(collectionId),
      skip: '0',
      take: String(take),
      getProductDescription: '0'
    });
    var sort = link.getAttribute('data-shop-sort');
    if (sort) params.set('sort', sort);
    if (window._usfLocale) params.set('locale', window._usfLocale);
    fetch(svc + 'search?' + params.toString(), { credentials: 'omit', mode: 'cors' }).catch(function () {});
  }

  function prefetchOtherTab() {
    document.querySelectorAll('.shop-collection-tabs__link:not(.is-active)').forEach(function (link) {
      if (link.href && !document.querySelector('link[rel="prefetch"][href="' + String(link.href).replace(/"/g, '') + '"]')) {
        var prefetch = document.createElement('link');
        prefetch.rel = 'prefetch';
        prefetch.href = link.href;
        document.head.appendChild(prefetch);
      }
      prefetchUsfCollection(link);
    });
    warmupHiddenFallback();
  }

  function bindInstantTabs() {
    var tabs = document.querySelector('.shop-collection-tabs');
    if (!tabs || tabs.dataset.shopInstant === '1') return;
    tabs.dataset.shopInstant = '1';
    tabs.addEventListener('click', function (event) {
      var link = event.target.closest('.shop-collection-tabs__link');
      if (!link) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
      if (link.classList.contains('is-active')) {
        event.preventDefault();
        return;
      }
      if (switchCollection(link)) event.preventDefault();
    });
    window.addEventListener('popstate', function () {
      var path = window.location.pathname;
      var handle = path.indexOf('strap-selector') !== -1 ? 'strap-selector' : path.indexOf('watch-selector') !== -1 ? 'watch-selector' : '';
      var link = handle && tabLinkFor(handle);
      if (link) switchCollection(link, { fromPop: true });
    });
  }

  function mount(options) {
    if (injecting) return;
    injecting = true;
    var shouldCollapse = !options || options.collapse !== false;
    try {
      if (injectChrome()) {
        bindFacetExclusiveOpen();
        bindOutsideClose();
        if (shouldCollapse && !didInitialCollapse) {
          didInitialCollapse = true;
          collapseAllFacets();
          window.setTimeout(collapseAllFacets, 50);
        }
        document.body.classList.add('shop-filters-ready');
      }
      markUsfReady();
    } finally {
      injecting = false;
    }
  }

  function fixDuplicatedCollectionPath() {
    var path = window.location.pathname.replace(/\/+$/, '');
    if (path.indexOf('/collections/watch-selector/watch-selector') !== -1) {
      window.location.replace(path.replace('/collections/watch-selector/watch-selector', '/collections/watch-selector') + window.location.search);
      return true;
    }
    if (path.indexOf('/collections/strap-selector/strap-selector') !== -1) {
      window.location.replace(path.replace('/collections/strap-selector/strap-selector', '/collections/strap-selector') + window.location.search);
      return true;
    }
    return false;
  }

  function init() {
    if (fixDuplicatedCollectionPath()) return;
    stripAvailableFromUrl();
    persistAvailable(availableOn);
    bindAvailableInputs();
    bindInstantTabs();
    prefetchOtherTab();
    mount();
  }

  if (window.usf && usf.event) {
    usf.event.add('init', init);
    usf.event.add('sr_updating', function () {
      if (waitForFreshUsf === 'listening' || waitForFreshUsf === 'pending') waitForFreshUsf = 'pending';
    });
    usf.event.add('sr_updated', function () {
      window.setTimeout(function () {
        if (waitForFreshUsf === true || waitForFreshUsf === 'listening') return;
        if (waitForFreshUsf === 'pending') {
          waitForFreshUsf = false;
          switching = false;
          collapseAllFacets();
          window.setTimeout(collapseAllFacets, 50);
        }
        mount({ collapse: false });
        markUsfReady();
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', mount);
})();
